module.exports = __webpack_public_path__ + "templates-59e97cd7/template-1-52ec88d6a3ca88343e9f65c321dd5c7a.jpg";